import { Route } from '@/app/router'

const Invoices = () => import('./index.vue')

const invoicesMeta = {
	sort: 14,
	displayInSidebar: true,
	displayName: 'invoice',
	icon: 'fal file-alt',
	activeIcon: 'fas file-alt'
}


export default new Route('/invoices', Invoices)
	.as('Dashboard:Invoices')
	.meta(invoicesMeta)
	.permissions(['IS_ADMIN'])
